import React from 'react'
import { Table, Space } from 'antd'
import Text from 'antd/es/typography/Text'
import PatternIcon from '../../../../../../../../components/common/PatternIcon'
import { useThemeColors } from '../../../../../../../../hooks/useThemeColors'

const DetailsTable = ({ record, phasesToShow }) => {
    const colors = useThemeColors()
    const RANGE_HIGHLIGHT_THRESHOLD = 10 // percent
    const detailColumns = [
        {
            title: 'Category',
            dataIndex: 'categoryName',
            key: 'categoryName',
            render: (text, row) => (
                <Space size={8}>
                    <PatternIcon color={row.color} id={row.categoryName} showId={false} sizeInPx={14} />
                    <Text>{text}</Text>
                </Space>
            ),
            width: 280,
        },
        ...phasesToShow.map(phaseName => ({
            title: phaseName,
            dataIndex: phaseName,
            key: `${record.key}-${phaseName}`,
            render: (val) => <Text>{val}%</Text>,
            align: 'center',
        })),
        {
            title: 'Range',
            key: 'range',
            render: (_, row) => {
                const values = phasesToShow.map(p => row[p] || 0)
                const max = Math.max(...values)
                const min = Math.min(...values)
                const diff = max - min
                const isLargeRange = diff >= RANGE_HIGHLIGHT_THRESHOLD
                return <Text style={{ color: isLargeRange ? colors.error : undefined }}>{diff}%</Text>
            },
            align: 'center',
            width: 100,
        },
    ]

    return (
        <Table
            columns={detailColumns}
            dataSource={record.details}
            pagination={false}
            size='small'
            rowKey='key'
        />
    )
}

export default DetailsTable


